export default "__VITE_ASSET__dhaERpZi__"